import { styled, keyframes } from '@mui/system';
import type { SVGProps } from 'react';

const rotateClockwise = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const SkeletonSvg = styled('svg')({
    display: 'block',
    overflow: 'hidden',
    '& .funding-navigator-fund-skeleton__circle-shade': {
        animation: `${rotateClockwise} 1.8s linear infinite`,
        transformBox: 'fill-box',
        transformOrigin: 'center'
    },
    '@media (prefers-reduced-motion: reduce)': {
        '& .funding-navigator-fund-skeleton__circle-shade': {
            animation: 'none'
        }
    }
});

export const FundingNavigatorFundSkeleton = (props: SVGProps<SVGSVGElement>) => (
    <SkeletonSvg width="338" height="166" viewBox="0 0 338 166" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
            <linearGradient id="fund-skeleton-bar-gradient" x1="1" y1="0" x2="0" y2="0" spreadMethod="reflect">
                <animateTransform
                    attributeName="gradientTransform"
                    type="translate"
                    values="0 0;2 0"
                    dur="1.8s"
                    repeatCount="indefinite"
                />
                <stop stopColor="#BCBDC3" />
                <stop offset="0.5" stopColor="#BCBDC3" stopOpacity="0.5" />
                <stop offset="1" stopColor="#BCBDC3" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="fund-skeleton-vertical-rule-gradient"
                x1="-2.5"
                y1="134.5"
                x2="5"
                y2="134.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#BCBDC3" stopOpacity="0" />
                <stop offset="1" stopColor="#BCBDC3" />
            </linearGradient>
            <clipPath id="fund-skeleton-top-content-clip">
                <rect x="97.5" y="20.5" width="164" height="56" />
            </clipPath>
            <clipPath id="fund-skeleton-bottom-content-clip">
                <rect x="0" y="104.5" width="338" height="60" />
            </clipPath>
            <clipPath id="fund-skeleton-circle-clip">
                <path d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM14.8 40C14.8 53.9176 26.0824 65.2 40 65.2C53.9176 65.2 65.2 53.9176 65.2 40C65.2 26.0824 53.9176 14.8 40 14.8C26.0824 14.8 14.8 26.0824 14.8 40Z" />
            </clipPath>
        </defs>

        <path d="M1.5 0.5H337.5" stroke="#BCBDC3" strokeLinecap="round" />
        <g opacity="0.5">
            <g transform="translate(1.5 8.5)" opacity="0.7">
                <g className="funding-navigator-fund-skeleton__circle-shade" clipPath="url(#fund-skeleton-circle-clip)">
                    <foreignObject x="0" y="0" width="80" height="80">
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                background: 'conic-gradient(from 90deg, #BCBDC3 0deg, rgba(188, 189, 195, 0) 360deg)'
                            }}
                        />
                    </foreignObject>
                </g>
            </g>

            <g clipPath="url(#fund-skeleton-top-content-clip)">
                <g opacity="0.7">
                    <rect x="113.5" y="20.5" width="16" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                    <rect x="137.5" y="20.5" width="68" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                    <rect x="113.5" y="40.5" width="16" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                    <rect x="137.5" y="40.5" width="105" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                    <rect x="113.5" y="60.5" width="16" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                    <rect x="137.5" y="60.5" width="53" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                </g>
            </g>
        </g>

        <path d="M1.5 96.5H337.5" stroke="#BCBDC3" strokeLinecap="round" />
        <g clipPath="url(#fund-skeleton-bottom-content-clip)" opacity="0.5">
            <g opacity="0.7">
                <path
                    d="M1.5 164.5L1.5 104.5"
                    stroke="url(#fund-skeleton-vertical-rule-gradient)"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                <rect x="9.5" y="104.5" width="16" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                <rect x="33.5" y="104.5" width="144" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                <rect x="9.5" y="128.5" width="320" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
                <rect x="9.5" y="148.5" width="183" height="16" rx="2" fill="url(#fund-skeleton-bar-gradient)" />
            </g>
        </g>
    </SkeletonSvg>
);


export default FundingNavigatorFundSkeleton;